import React from 'react'
import PropTypes from 'prop-types'
import {Button, CircularProgress, colors, withStyles} from '@material-ui/core'

const styles = {
    actionButton: {
        backgroundColor: colors.green[500],
        color: '#fff',
        paddingLeft: '5em',
        paddingRight: '5em',
        '&:hover': {
            backgroundColor: colors.green[600],
            '&$disabled': {
                color: 'inherit'
            }
        }
    },

    actionButtonText: {
        color: '#fff'
    },
    disabled: {},

    actionButtonDisabled: {
        backgroundColor: colors.grey[300]
    },

    actionButtonLoading: {
        backgroundColor: colors.orange[600],
        '&:hover': {
            backgroundColor: colors.orange[600]
        }
    },

    progress: {
        position: 'absolute',
        right: '3em'
    }
};

const SubmitButton = function({classes: styles, className, isDisabled, isProcessing, onClick, loadingText, children}) {
    return (
        <Button color="inherit" disabled={isDisabled || isProcessing} classes={{
            root: `${styles.actionButton} ${className}`,
            label: styles.actionButtonText,
            disabled: isProcessing ? styles.actionButtonLoading : styles.actionButtonDisabled
        }} onClick={onClick}
        >
            { isProcessing ? loadingText : children}
            { isProcessing && <CircularProgress style={{ color: '#fff' }} className={styles.progress} size={20} thickness={5} />}
        </Button>
    )
}

SubmitButton.propTypes = {
    classes: PropTypes.object,
    isDisabled: PropTypes.bool,
    isProcessing: PropTypes.bool,
    children: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    onClick: PropTypes.func.isRequired,
    loadingText: PropTypes.string,
    className: PropTypes.string
}

SubmitButton.defaultProps = {
    isDisabled: false,
    isProcessing: false,
    children: 'Submit',
    loadingText: 'Please Wait..'
}

export default withStyles(styles)(SubmitButton);
